 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app~d0ae3f07": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app~d0ae3f07": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"CashiersReport~ReconcilliationReport~ShiftsPage~ShiftsSummaryPage~5a11b65b":"CashiersReport~ReconcilliationReport~ShiftsPage~ShiftsSummaryPage~5a11b65b","CashiersReport~3cff1876":"CashiersReport~3cff1876","ReconcilliationReport~3d9b8e9e":"ReconcilliationReport~3d9b8e9e","ShiftsPage~7b99007c":"ShiftsPage~7b99007c","ShiftsSummaryPage~7b99007c":"ShiftsSummaryPage~7b99007c","CigPricing~FuelTransactions~FunctionLoggingPage~InventoryCounts~InventoryPricing~InventoryPricingOld~995d1331":"CigPricing~FuelTransactions~FunctionLoggingPage~InventoryCounts~InventoryPricing~InventoryPricingOld~995d1331","CigPricing~LocationSummary~LocationTopSales~5f8b619c":"CigPricing~LocationSummary~LocationTopSales~5f8b619c","CigPricing~289fef09":"CigPricing~289fef09","LocationSummary~d9b04994":"LocationSummary~d9b04994","LocationTopSales~31ecd969":"LocationTopSales~31ecd969","FuelTransactions~2bef4c9a":"FuelTransactions~2bef4c9a","FunctionLoggingPage~ada1a736":"FunctionLoggingPage~ada1a736","InventoryCounts~91fc7b4f":"InventoryCounts~91fc7b4f","InventoryPricingOld~9485fcd6":"InventoryPricingOld~9485fcd6","InventoryPricing~8da09961":"InventoryPricing~8da09961","InventorySearch~8da09961":"InventorySearch~8da09961","InvoiceLookup~f343ce24":"InvoiceLookup~f343ce24","InvoiceRawTransactions~df778dff":"InvoiceRawTransactions~df778dff","LatestSales~cff68577":"LatestSales~cff68577","LocationSalesComparison~9e838ac8":"LocationSalesComparison~9e838ac8","OperatorPage~ada1a736":"OperatorPage~ada1a736","POSLookup~f9903a64":"POSLookup~f9903a64","POSRawTransactions~bce24b05":"POSRawTransactions~bce24b05","PhoneDebugPage~06f55fc1":"PhoneDebugPage~06f55fc1","PumpStatusPage~2f09c1d9":"PumpStatusPage~2f09c1d9","ShiftReconciliation~5a38c53c":"ShiftReconciliation~5a38c53c","ShiftSummary~19c6413e":"ShiftSummary~19c6413e","SummaryReport01~5367f10f":"SummaryReport01~5367f10f","Totalizers~4a5b547f":"Totalizers~4a5b547f","login~e62db531":"login~e62db531","DailyTripSummary~67faecf8":"DailyTripSummary~67faecf8","FuelSummaryReport~7f81c72a":"FuelSummaryReport~7f81c72a","Intro~2bc82104":"Intro~2bc82104","ManualTranscations~6477de3c":"ManualTranscations~6477de3c","MonthlyPOSPage~5a11b65b":"MonthlyPOSPage~5a11b65b","PAPCreditVsDebit~7f81c72a":"PAPCreditVsDebit~7f81c72a","SLGATransactionReport~5a11b65b":"SLGATransactionReport~5a11b65b","SQLReports~d19e04fe":"SQLReports~d19e04fe","SafeDropSummaryReport~16634e09":"SafeDropSummaryReport~16634e09","ShiftsPageOld~7b99007c":"ShiftsPageOld~7b99007c","main~21833f8f":"main~21833f8f","twilio-sync~748942c6":"twilio-sync~748942c6","twilio-sync~690b702c":"twilio-sync~690b702c","twilio-sync~90b080da":"twilio-sync~90b080da","twilio-sync~1c3a2c3f":"twilio-sync~1c3a2c3f","twilio-sync~9b697c50":"twilio-sync~9b697c50","twilio-sync~6f08d4fc":"twilio-sync~6f08d4fc","vue-apexcharts~2a42e354":"vue-apexcharts~2a42e354"}[chunkId]||chunkId) + "." + {"CashiersReport~ReconcilliationReport~ShiftsPage~ShiftsSummaryPage~5a11b65b":"73d69f07","CashiersReport~3cff1876":"5dac6768","ReconcilliationReport~3d9b8e9e":"430a03b8","ShiftsPage~7b99007c":"f4babded","ShiftsSummaryPage~7b99007c":"6bfcf4ed","CigPricing~FuelTransactions~FunctionLoggingPage~InventoryCounts~InventoryPricing~InventoryPricingOld~995d1331":"116bfbe4","CigPricing~LocationSummary~LocationTopSales~5f8b619c":"0b6c2b11","CigPricing~289fef09":"4ec50a1c","LocationSummary~d9b04994":"3a09e324","LocationTopSales~31ecd969":"9182138d","FuelTransactions~2bef4c9a":"8882cf90","FunctionLoggingPage~ada1a736":"8312c2c0","InventoryCounts~91fc7b4f":"14e52d6d","InventoryPricingOld~9485fcd6":"2c0f8868","InventoryPricing~8da09961":"bc24df1a","InventorySearch~8da09961":"d549890e","InvoiceLookup~f343ce24":"230107c9","InvoiceRawTransactions~df778dff":"2fb95f23","LatestSales~cff68577":"b26d6c72","LocationSalesComparison~9e838ac8":"e1e06083","OperatorPage~ada1a736":"674b704b","POSLookup~f9903a64":"d94b1ca5","POSRawTransactions~bce24b05":"584bff28","PhoneDebugPage~06f55fc1":"b994892f","PumpStatusPage~2f09c1d9":"0680dacc","ShiftReconciliation~5a38c53c":"8eaf4172","ShiftSummary~19c6413e":"38496bcc","SummaryReport01~5367f10f":"0fb5494f","Totalizers~4a5b547f":"1c32ea03","login~e62db531":"69299e8c","DailyTripSummary~67faecf8":"7725dac7","FuelSummaryReport~7f81c72a":"ed7319dc","Intro~2bc82104":"1944b2a2","ManualTranscations~6477de3c":"c112c2ac","MonthlyPOSPage~5a11b65b":"b2d339c0","PAPCreditVsDebit~7f81c72a":"cf95c6e8","SLGATransactionReport~5a11b65b":"821e1445","SQLReports~d19e04fe":"632cbe09","SafeDropSummaryReport~16634e09":"77d6602f","ShiftsPageOld~7b99007c":"5fc39013","main~21833f8f":"0dc91e27","twilio-sync~748942c6":"f5132588","twilio-sync~690b702c":"16fe5b0f","twilio-sync~90b080da":"fb1e3ee7","twilio-sync~1c3a2c3f":"bb81c493","twilio-sync~9b697c50":"437a9914","twilio-sync~6f08d4fc":"5dc6e560","vue-apexcharts~2a42e354":"001abb01"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"ReconcilliationReport~3d9b8e9e":1,"CigPricing~289fef09":1,"LocationSummary~d9b04994":1,"LocationTopSales~31ecd969":1,"InventoryPricing~8da09961":1,"PhoneDebugPage~06f55fc1":1,"ShiftReconciliation~5a38c53c":1,"ShiftSummary~19c6413e":1,"login~e62db531":1,"main~21833f8f":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"CashiersReport~ReconcilliationReport~ShiftsPage~ShiftsSummaryPage~5a11b65b":"CashiersReport~ReconcilliationReport~ShiftsPage~ShiftsSummaryPage~5a11b65b","CashiersReport~3cff1876":"CashiersReport~3cff1876","ReconcilliationReport~3d9b8e9e":"ReconcilliationReport~3d9b8e9e","ShiftsPage~7b99007c":"ShiftsPage~7b99007c","ShiftsSummaryPage~7b99007c":"ShiftsSummaryPage~7b99007c","CigPricing~FuelTransactions~FunctionLoggingPage~InventoryCounts~InventoryPricing~InventoryPricingOld~995d1331":"CigPricing~FuelTransactions~FunctionLoggingPage~InventoryCounts~InventoryPricing~InventoryPricingOld~995d1331","CigPricing~LocationSummary~LocationTopSales~5f8b619c":"CigPricing~LocationSummary~LocationTopSales~5f8b619c","CigPricing~289fef09":"CigPricing~289fef09","LocationSummary~d9b04994":"LocationSummary~d9b04994","LocationTopSales~31ecd969":"LocationTopSales~31ecd969","FuelTransactions~2bef4c9a":"FuelTransactions~2bef4c9a","FunctionLoggingPage~ada1a736":"FunctionLoggingPage~ada1a736","InventoryCounts~91fc7b4f":"InventoryCounts~91fc7b4f","InventoryPricingOld~9485fcd6":"InventoryPricingOld~9485fcd6","InventoryPricing~8da09961":"InventoryPricing~8da09961","InventorySearch~8da09961":"InventorySearch~8da09961","InvoiceLookup~f343ce24":"InvoiceLookup~f343ce24","InvoiceRawTransactions~df778dff":"InvoiceRawTransactions~df778dff","LatestSales~cff68577":"LatestSales~cff68577","LocationSalesComparison~9e838ac8":"LocationSalesComparison~9e838ac8","OperatorPage~ada1a736":"OperatorPage~ada1a736","POSLookup~f9903a64":"POSLookup~f9903a64","POSRawTransactions~bce24b05":"POSRawTransactions~bce24b05","PhoneDebugPage~06f55fc1":"PhoneDebugPage~06f55fc1","PumpStatusPage~2f09c1d9":"PumpStatusPage~2f09c1d9","ShiftReconciliation~5a38c53c":"ShiftReconciliation~5a38c53c","ShiftSummary~19c6413e":"ShiftSummary~19c6413e","SummaryReport01~5367f10f":"SummaryReport01~5367f10f","Totalizers~4a5b547f":"Totalizers~4a5b547f","login~e62db531":"login~e62db531","DailyTripSummary~67faecf8":"DailyTripSummary~67faecf8","FuelSummaryReport~7f81c72a":"FuelSummaryReport~7f81c72a","Intro~2bc82104":"Intro~2bc82104","ManualTranscations~6477de3c":"ManualTranscations~6477de3c","MonthlyPOSPage~5a11b65b":"MonthlyPOSPage~5a11b65b","PAPCreditVsDebit~7f81c72a":"PAPCreditVsDebit~7f81c72a","SLGATransactionReport~5a11b65b":"SLGATransactionReport~5a11b65b","SQLReports~d19e04fe":"SQLReports~d19e04fe","SafeDropSummaryReport~16634e09":"SafeDropSummaryReport~16634e09","ShiftsPageOld~7b99007c":"ShiftsPageOld~7b99007c","main~21833f8f":"main~21833f8f","twilio-sync~748942c6":"twilio-sync~748942c6","twilio-sync~690b702c":"twilio-sync~690b702c","twilio-sync~90b080da":"twilio-sync~90b080da","twilio-sync~1c3a2c3f":"twilio-sync~1c3a2c3f","twilio-sync~9b697c50":"twilio-sync~9b697c50","twilio-sync~6f08d4fc":"twilio-sync~6f08d4fc","vue-apexcharts~2a42e354":"vue-apexcharts~2a42e354"}[chunkId]||chunkId) + "." + {"CashiersReport~ReconcilliationReport~ShiftsPage~ShiftsSummaryPage~5a11b65b":"31d6cfe0","CashiersReport~3cff1876":"31d6cfe0","ReconcilliationReport~3d9b8e9e":"b5153421","ShiftsPage~7b99007c":"31d6cfe0","ShiftsSummaryPage~7b99007c":"31d6cfe0","CigPricing~FuelTransactions~FunctionLoggingPage~InventoryCounts~InventoryPricing~InventoryPricingOld~995d1331":"31d6cfe0","CigPricing~LocationSummary~LocationTopSales~5f8b619c":"31d6cfe0","CigPricing~289fef09":"3b6f9d39","LocationSummary~d9b04994":"fdb95ddd","LocationTopSales~31ecd969":"b5baa61b","FuelTransactions~2bef4c9a":"31d6cfe0","FunctionLoggingPage~ada1a736":"31d6cfe0","InventoryCounts~91fc7b4f":"31d6cfe0","InventoryPricingOld~9485fcd6":"31d6cfe0","InventoryPricing~8da09961":"4c54faf8","InventorySearch~8da09961":"31d6cfe0","InvoiceLookup~f343ce24":"31d6cfe0","InvoiceRawTransactions~df778dff":"31d6cfe0","LatestSales~cff68577":"31d6cfe0","LocationSalesComparison~9e838ac8":"31d6cfe0","OperatorPage~ada1a736":"31d6cfe0","POSLookup~f9903a64":"31d6cfe0","POSRawTransactions~bce24b05":"31d6cfe0","PhoneDebugPage~06f55fc1":"81e9c03b","PumpStatusPage~2f09c1d9":"31d6cfe0","ShiftReconciliation~5a38c53c":"30051bcc","ShiftSummary~19c6413e":"b91cde70","SummaryReport01~5367f10f":"31d6cfe0","Totalizers~4a5b547f":"31d6cfe0","login~e62db531":"e7c5e3c5","DailyTripSummary~67faecf8":"31d6cfe0","FuelSummaryReport~7f81c72a":"31d6cfe0","Intro~2bc82104":"31d6cfe0","ManualTranscations~6477de3c":"31d6cfe0","MonthlyPOSPage~5a11b65b":"31d6cfe0","PAPCreditVsDebit~7f81c72a":"31d6cfe0","SLGATransactionReport~5a11b65b":"31d6cfe0","SQLReports~d19e04fe":"31d6cfe0","SafeDropSummaryReport~16634e09":"31d6cfe0","ShiftsPageOld~7b99007c":"31d6cfe0","main~21833f8f":"39462e5f","twilio-sync~748942c6":"31d6cfe0","twilio-sync~690b702c":"31d6cfe0","twilio-sync~90b080da":"31d6cfe0","twilio-sync~1c3a2c3f":"31d6cfe0","twilio-sync~9b697c50":"31d6cfe0","twilio-sync~6f08d4fc":"31d6cfe0","vue-apexcharts~2a42e354":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors~253ae210","chunk-vendors~4572b388","chunk-vendors~11bb84b7","chunk-vendors~2b0144e0","chunk-vendors~77bf5e45","chunk-vendors~fdc6512a","chunk-vendors~d2305125"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
